module.exports = __webpack_public_path__ + "img/buddy_mouth-03.aff23971.svg";